import * as ArtistBio from '../block/ArtistBio.jsx';
import ArtistImageParallax from '../block/ArtistImageParallax.jsx';
import * as ArtistListCell from '../block/ArtistListCell.jsx';
import { ArtistSignupV1, ArtistSignupV2, SubmitButton as ArtistSignupSubmitButton, SuccessMessage as ArtistSignupSuccessMessage } from '../block/ArtistSignup.jsx';
import ArtistsList from '../block/ArtistsList.jsx';
import ArtistTabbed from '../block/ArtistTabbed.jsx';
import BlogImageParallax from '../block/BlogImageParallax.jsx';
import BlogPost from '../block/BlogPost.jsx';
import BlogsList from '../block/BlogsList.jsx';
import * as BlogListCell from '../block/BlogListCell.jsx';
import { ButtonV1, ButtonV2, ButtonV3 } from '../block/Button.jsx';
import { CardFormV1, CardFormV2 } from '../block/CardForm.jsx';
import * as Cart from '../block/Cart.jsx';
import { InventoryQuantityInput, PromoCodeMeta } from '../block/CartLineItemCell.jsx';
import CloseButton from '../block/CloseButton.jsx';
import Checkbox from '../block/Checkbox.jsx';
import Code from '../block/Code.jsx';
import * as Contact from '../block/Contact.jsx';
import ContactForm from '../block/ContactForm.jsx';
import Custom from '../block/Custom.jsx';
import DisplayHeader from '../block/DisplayHeader.jsx';
import EditionSets from '../block/EditionSets.jsx';
import ErrorMessage from '../block/ErrorMessage.jsx';
import { FormButton, SuccessMessage } from './Form.jsx';
import HeaderText from '../block/HeaderText.jsx';
import { ImageV1, ImageV2 } from '../block/Image.jsx';
import ImageGallery from '../block/ImageGallery.jsx';
import Input from '../block/Input.jsx';
import { InquireForm } from '../block/InquirePopup.jsx';
import InstallationPhotos from '../block/InstallationPhotos.jsx';
import InventoryArtistProfileButton from '../block/InventoryArtistProfileButton.jsx';
import { ButtonType as InventoryCTAButtonType, InquireButton, InventoryControls, InventoryCTAButton, OfferButton, PurchaseButton } from '../block/InventoryCTA.jsx';
import InventoryImageParallax from '../block/InventoryImageParallax.jsx';
import { InventoryListV1, InventoryListV2, InventoryListV3, InventoryListV4 } from '../block/InventoryList.jsx';
import * as InventoryListCell from '../block/InventoryListCell.jsx';
import * as InventoryMeta from '../block/InventoryMeta.jsx';
import Map from '../block/Map.jsx';
import MediaList from '../block/MediaList.jsx';
import ModalButton from '../block/ModalButton.jsx';
import { OfferForm } from '../block/OfferPopup.jsx';
import { PageTitleV1, PageTitleV2 } from '../block/PageTitle.jsx';
import Parallax from '../block/Parallax.jsx';
import { PasswordForm } from '../block/PasswordProtection.jsx';
import * as PostContent from '../block/PostContent.jsx';
import { PromoCodeV1, PromoCodeV2 } from '../block/PromoCodeForm.jsx';
import {
    CartButtonV1,
    CartButtonV2,
    ContinueButtonV1,
    ContinueButtonV2,
    DropDownV1 as PurchasePopupDropDownV1,
    DropDownV2 as PurchasePopupDropDownV2,
    SubmitButtonV1 as PurchasePopupSubmitButtonV1,
    SubmitButtonV2 as PurchasePopupSubmitButtonV2
} from '../block/PurchasePopup.jsx';
import RecentlyViewed from '../block/RecentlyViewed.jsx';
import * as RecentlyViewedCell from '../block/RecentlyViewedCell.jsx';
import RepresentativesList from '../block/RepresentativesList.jsx';
import * as RepresentativeListCell from '../block/RepresentativeListCell.jsx';
import * as SearchResultCell from '../block/SearchResultCell.jsx';
import SearchResults from '../block/SearchResults.jsx';
import ShowDescription from '../block/ShowDescription.jsx';
import ShowImageParallax from '../block/ShowImageParallax.jsx';
import { ShowsListGrid, ShowsListParallax, ShowsListSlideshow } from '../block/ShowsList.jsx';
import * as ShowListCell from '../block/ShowListCell.jsx';
import ShowMeta from '../block/ShowMeta.jsx';
import { SignUpButtonV1, SignUpButtonV2, SignUpButtonV3 } from '../block/SignUpButton.jsx';
import Slider from '../block/Slider.jsx';
import * as SliderCell from '../block/SliderCell.jsx';
import Social from '../block/Social.jsx';
import { StripeElementsComponent } from '../block/StripeElements.jsx';
import { SubscribeFormV1, SubscribeFormV2 } from '../block/SubscribeForm.jsx';
import { default as SubscribePopup } from '../block/SubscribePopup.jsx';
import { Legacy as TabsLegacy, TabsV1, TabsV2, TabsV3 } from '../block/Tabs.jsx';
import Text from '../block/Text.jsx';
import TextArea from '../block/TextArea.jsx';
import Video from '../block/Video.jsx';

import Accordion from '../block/Accordion.jsx';
import Columns from '../block/Columns.jsx';
import HoverContent from '../block/HoverContent.jsx';

import { DesignKit, LegacyThemeStyle, WhiteLabelStyle } from '../layout/CustomizedStyle.jsx';
import { default as FontImport } from '../layout/FontImport.jsx';
import * as Footer from '../layout/Footer.jsx';
import * as Header from '../layout/Header.jsx';
import { HomeLinkV1, HomeLinkV2 } from '../layout/HomeLink.jsx';
import Kit from '../layout/Kit.jsx';
import * as Legacy from '../layout/Legacy.jsx';
import PageRegistry from './PageRegistry.jsx';

import { NotFound } from '../common/Container.jsx';
import FormField from './FormField.jsx';
import InventoryHelper from './Inventory.jsx';
import Layout from './Layout.jsx';
import Name from './Name.jsx';
import PageType from './PageType.jsx';
import ScreenSize from './ScreenSize.jsx';
import Token from './Token.jsx';
import Utilities from './Utilities.jsx';

const Types = {
    Block: {
        Name: Name.Block,
        getAllComponents: function () {
            return {
                ArtistBio: {
                    Image: ArtistBio.ImageV1.Component,
                    Legacy: ArtistBio.Legacy.Component,
                    Name: ArtistBio.NameV1.Component,
                    Tokenized: ArtistBio.Tokenized.Component
                },
                ArtistSignup: ArtistSignupV1.Component,
                ArtistsList: ArtistsList.Component,
                ArtistTabbed,
                BlogPost,
                BlogMeta: PostContent.Meta.Component,
                BlogsList: BlogsList.Component,
                Button: ButtonV2.Component,
                ButtonV1: ButtonV1.Component,
                CloseButton: CloseButton.Component,
                Code: Code.Component,
                Contact: {
                    Address: Contact.Address.Component,
                    Form: Contact.ContactFormV1.Component,
                    Hours: Contact.Hours.Component
                },
                ContactForm,
                Custom: Custom.Component,
                DisplayHeader: DisplayHeader.Component,
                Image: ImageV1.Component,
                ImageGallery: ImageGallery.Component,
                InstallationPhotos: InstallationPhotos.Component,
                InventoryControls: InventoryControls.Component,
                InventoryCTAButton: InventoryCTAButton.Component,
                InventoryInquireButton: InquireButton.Component,
                InventoryOfferButton: OfferButton.Component,
                InventoryPurchaseButton: PurchaseButton.Component,
                InventoryList: InventoryListV1.Component,
                InventoryMeta: {
                    Image: InventoryMeta.Image.Component,
                    Legacy: InventoryMeta.Legacy.Component,
                    Tokenized: InventoryMeta.Tokenized.Component
                },
                Map: Map.Component,
                MediaList: MediaList.Component,
                PageTitle: PageTitleV1.Component,
                SearchResults: {
                    List: SearchResults.List.Component,
                    Meta: SearchResults.Meta.Component
                },
                ShowDescription,
                ShowMeta: {
                    Image: ShowMeta.ImageV2.Component,
                    ImageV1: ShowMeta.ImageV1.Component,
                    Tokenized: ShowMeta.Tokenized.Component
                },
                ShowsList: {
                    Grid: ShowsListGrid.Component,
                    Parallax: ShowsListParallax.Component,
                    Slideshow: ShowsListSlideshow.Component
                },
                SignUpButtonV1: SignUpButtonV1.Component,
                SignUpButtonV2: SignUpButtonV2.Component,
                Slider: Slider.Component,
                SliderLegacy: Slider.Legacy,
                Social: Social.V2.Component,
                SubscribeModal: SubscribePopup,
                Tabs: {
                    Container: TabsV1.Component,
                    Legacy: TabsLegacy.Component
                },
                Text: Text.Component,
                Video: Video.Component,

                Layout: {
                    Columns: Columns.Component,
                    DesignKit,
                    FontImport: {
                        Custom: FontImport.Custom,
                        Google: FontImport.Google
                    },
                    HoverContent: HoverContent.Component,
                    LegacyThemeStyle,
                    WhiteLabelStyle
                },

                Page: {
                    // Body is retrieved from PageRegistry to break circular dependency
                    get Body() {
                        return PageRegistry.get('Body');
                    },
                    LegacyFooter: Legacy.Footer,
                    LegacyHeader: Legacy.Header
                }
            };
        },
        getComponentAndData: function (block, pageType, providedData, websiteConfig) {
            if (!block || !block.type) {
                return null;
            }
            let Component, context, data, jsonLD;
            switch (block.type.value) {
                // LEGACY BLOCKS
                case 0:
                    Component = Custom.Component;
                    break;
                case 1:
                    Component = ArtistsList.Component;
                    break;
                case 2:
                case 6:
                case 10:
                case 16:
                    Component = InventoryListV1.Component;
                    break;
                case 3:
                case 26:
                    Component = ShowsListGrid.Component;
                    break;
                case 4:
                    Component = ContactForm;
                    break;
                case 5:
                    Component = Slider.Legacy;
                    break;
                case 7:
                case 18:
                    Component = ArtistBio.Legacy.Component;
                    data = block;
                    break;
                case 8:
                case 12:
                case 28:
                    Component = DisplayHeader.Component;
                    data = block.display;
                    break;
                case 9:
                    Component = ArtistTabbed;
                    data = block;
                    break;
                case 11:
                    Component = ShowDescription;
                    data = block;
                    break;
                case 13:
                    Component = InventoryMeta.Legacy.Component;
                    data = providedData;
                    break;
                case 14:
                    Component = InstallationPhotos.Component;
                    data = block.images;
                    break;
                case 15:
                case 19:
                case 20:
                case 21:
                    Component = BlogsList.Component;
                    break;
                case 17:
                    Component = ArtistSignupV1.Component;
                    data = block;
                    break;
                case 22:
                case 23:
                case 24:
                case 27:
                    Component = MediaList.Component;
                    break;
                case 25:
                    Component = TabsLegacy.Component;
                    data = block.data;
                    break;
                case 29:
                    Component = ImageGallery.Component;
                    break;
                case 30:
                    Component = ShowsListParallax.Component;
                    break;
                // ARTIST
                case Types.Block.Name.Artist.Cell.Image:
                    Component = ArtistListCell.ArtistImage.Component;
                // Intentional fallthrough
                case Types.Block.Name.Artist.Cell.Text:
                    if (!Component) {
                        Component = ArtistListCell.ArtistMeta.Component;
                    }
                case Types.Block.Name.Artist.ImageParallax:
                    if (!Component) {
                        Component = ArtistImageParallax.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.SearchResult.Cell.Image.Artist:
                    if (!Component) {
                        Component = SearchResultCell.ArtistSearchResultImage.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.SearchResult.Cell.Text.Artist:
                    if (!Component) {
                        Component = SearchResultCell.ArtistSearchResultMeta.Component;
                    }
                    data = providedData;
                    if (data && data.artist) {
                        data = data.artist;
                    }
                    break;
                case Types.Block.Name.Artist.Bio.Text:
                case Types.Block.Name.Artist.CV:
                case Types.Block.Name.Inventory.Artist.Bio.Text:
                    Component = ArtistBio.Tokenized.Component;
                // Intentional fallthrough
                case Types.Block.Name.Artist.ImageV1:            // DEPRECATED - use `Types.Block.Name.Artist.ImageV1`
                case Types.Block.Name.Inventory.Artist.ImageV1:  // DEPRECATED - use `Types.Block.Name.Inventory.Artist.ImageV1`
                    if (!Component) {
                        Component = ArtistBio.ImageV1.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Artist.ImageV2:
                case Types.Block.Name.Inventory.Artist.ImageV2:
                    if (!Component) {
                        Component = ArtistBio.ImageV2.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Artist.NameV2:            // DEPRECATED - use `Types.Block.Name.Artist.NameV1`
                case Types.Block.Name.Inventory.Artist.NameV2:  // DEPRECATED - use `Types.Block.Name.Inventory.Artist.NameV1`
                    if (!Component) {
                        Component = ArtistBio.NameV2.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Artist.NameV1:
                    if (!Component) {
                        Component = ArtistBio.NameV1.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Inventory.Artist.NameV1:
                    if (!Component) {
                        Component = ArtistBio.NameV1.InventoryComponent;
                    }
                    if (websiteConfig && websiteConfig.userType == 1) {
                        data = websiteConfig.artist;
                    } else if (providedData) {
                        if (providedData.inventory) {
                            data = providedData.inventory.artist;
                        } else {
                            data = providedData.artist;
                        }
                    }
                    break;
                case Types.Block.Name.Artist.List:
                case Types.Block.Name.Artist.ListV2:
                case Types.Block.Name.Show.Artist.List:
                case Types.Block.Name.Show.Artist.ListV2:
                    Component = ArtistsList.Component;
                    context = {};
                    if (providedData) {
                        if (providedData.show) {
                            context.listId = providedData.show.id;
                        }
                        jsonLD = providedData.artistsJsonLD;
                    }
                    if (block && block.config && block.config.block) {
                        // Set in context, even though read from blockConfig => Helps inform builder updates that require data fetch
                        context.maxLimit = block.config.block.maxLimit;
                        context.order = block.config.block.order;
                        context.tag = block.config.block.tags;
                    }
                    break;
                case Types.Block.Name.Artist.SignupV1:          // DEPRECATED - use `Types.Block.Name.Artist.Signup.Container`
                    Component = ArtistSignupV1.Component;
                // Intentional fallthrough
                case Types.Block.Name.Artist.Signup.Container:
                    if (!Component) {
                        Component = ArtistSignupV2.Component;
                    }
                    if (providedData) {
                        data = providedData.artist;
                    }
                    break;
                // BLOG/MEDIA
                case Types.Block.Name.Artist.Blog.List:
                case Types.Block.Name.Blog.List:
                case Types.Block.Name.Inventory.Blog.List:
                case Types.Block.Name.Show.Blog.List:
                    Component = BlogsList.Component;
                    context = {};
                    jsonLD = providedData && providedData.blogsJsonLD;

                    if (block && block.config && block.config.block) {
                        // Set in context, even though read from blockConfig => Helps inform builder updates that require data fetch
                        context.maxLimit = block.config.block.maxLimit;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Artist.Media.List:
                case Types.Block.Name.Inventory.Media.List:
                case Types.Block.Name.Media.List:
                case Types.Block.Name.Show.Media.List:
                    if (!Component) {
                        Component = MediaList.Component;
                        context = {};
                    }
                    if (providedData) {
                        if (providedData.artist) {
                            context.artistId = providedData.artist.id;
                        }
                        if (providedData.inventory) {
                            context.inventoryId = providedData.inventory.id;
                        }
                        if (providedData.show) {
                            context.listId = providedData.show.id;
                        }
                    }
                    if (block && block.config && block.config.block) {
                        // Set in context, even though read from blockConfig => Helps inform builder updates that require data fetch
                        context.tags = block.config.block.tags;
                    }
                    break;
                case Types.Block.Name.Blog.Cell.Image:
                    Component = BlogListCell.BlogImage.Component;
                    data = providedData && providedData.blog || providedData;
                    break;
                case Types.Block.Name.Blog.Cell.Text:
                    Component = BlogListCell.BlogMeta.Component;
                    data = providedData && providedData.blog || providedData;
                    break;
                case Types.Block.Name.Blog.ImageParallax:
                    Component = BlogImageParallax.Component;
                // Intentional fallthrough
                case Types.Block.Name.Blog.Meta:
                case Types.Block.Name.Blog.TitleV2:
                    if (!Component) {
                        Component = PostContent.Meta.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Blog.TitleV1:             // DEPRECATED - use `Types.Block.Name.Blog.TitleV2`
                    if (!Component) {
                        Component = PostContent.Title.Component;
                    }
                    if (providedData) {
                        data = providedData.blog;
                    }
                    break;
                // CART
                case Types.Block.Name.Cart.ApplePayButton:
                    Component = Cart.ApplePayButton.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.Cart.CardFormV1:          // DEPRECATED - use `Types.Block.Name.Cart.CardForm.Container`
                    Component = CardFormV1.Component;
                // Intentional fallthrough
                case Types.Block.Name.Cart.CardForm.Container:
                    if (!Component) {
                        Component = CardFormV2.Component;
                    }
                    data = providedData;
                    break;
                case Types.Block.Name.Cart.StripeElements:
                    Component = StripeElementsComponent;
                    data = providedData;
                    break;
                case Types.Block.Name.Cart.LineItem.Cell.InventoryLineItemQuantityInput:
                    Component = InventoryQuantityInput.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.Cart.LineItem.Cell.PromoCodeLineItemText:
                    Component = PromoCodeMeta.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.Cart.LineItem.List:
                    Component = Cart.LineItems.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.Cart.PromoCodeV1:         // DEPRECATED - use `Types.Block.Name.Cart.PromoCode.Container`
                    Component = PromoCodeV1.Component;
                // Intentional fallthrough
                case Types.Block.Name.Cart.PromoCode.Container:
                    if (!Component) {
                        Component = PromoCodeV2.Component;
                    }
                    data = providedData;
                    break;
                case Types.Block.Name.Cart.Shipping:
                case Types.Block.Name.Cart.Subtotal:
                case Types.Block.Name.Cart.Tax:
                    Component = Cart.Total.Component;
                    data = providedData;
                    break;
                // FORM
                case Types.Block.Name.Cart.CardForm.SameAddressCheckbox:
                    Component = Checkbox.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.Artist.Signup.ErrorMessage:
                case Types.Block.Name.Cart.CardForm.ErrorMessage:
                case Types.Block.Name.Cart.PromoCode.ErrorMessage:
                case Types.Block.Name.Contact.Form.ErrorMessage:
                case Types.Block.Name.Footer.SubscribeForm.ErrorMessage:
                case Types.Block.Name.InquireForm.ErrorMessage:
                case Types.Block.Name.OfferForm.ErrorMessage:
                case Types.Block.Name.PasswordForm.ErrorMessage:
                case Types.Block.Name.SubscribeForm.ErrorMessage:
                    Component = ErrorMessage.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.Artist.Signup.Input.Email:
                case Types.Block.Name.Artist.Signup.Input.Name:
                case Types.Block.Name.Cart.CardForm.Input.BillingAddress.AddressLine1:
                case Types.Block.Name.Cart.CardForm.Input.BillingAddress.AddressLine2:
                case Types.Block.Name.Cart.CardForm.Input.BillingAddress.City:
                case Types.Block.Name.Cart.CardForm.Input.BillingAddress.Country:
                case Types.Block.Name.Cart.CardForm.Input.BillingAddress.State:
                case Types.Block.Name.Cart.CardForm.Input.BillingAddress.Zip:
                case Types.Block.Name.Cart.CardForm.Input.CardNumber:
                case Types.Block.Name.Cart.CardForm.Input.Email:
                case Types.Block.Name.Cart.CardForm.Input.ExpirationDate:
                case Types.Block.Name.Cart.CardForm.Input.FirstName:
                case Types.Block.Name.Cart.CardForm.Input.LastName:
                case Types.Block.Name.Cart.CardForm.Input.Notes:
                case Types.Block.Name.Cart.CardForm.Input.Phone:
                case Types.Block.Name.Cart.CardForm.Input.SecurityCode:
                case Types.Block.Name.Cart.CardForm.Input.ShippingAddress.AddressLine1:
                case Types.Block.Name.Cart.CardForm.Input.ShippingAddress.AddressLine2:
                case Types.Block.Name.Cart.CardForm.Input.ShippingAddress.City:
                case Types.Block.Name.Cart.CardForm.Input.ShippingAddress.Country:
                case Types.Block.Name.Cart.CardForm.Input.ShippingAddress.State:
                case Types.Block.Name.Cart.CardForm.Input.ShippingAddress.Zip:
                case Types.Block.Name.Cart.PromoCode.Input.Code:
                case Types.Block.Name.Contact.Form.Input.Address.City:
                case Types.Block.Name.Contact.Form.Input.Address.Country:
                case Types.Block.Name.Contact.Form.Input.Address.Line1:
                case Types.Block.Name.Contact.Form.Input.Address.Line2:
                case Types.Block.Name.Contact.Form.Input.Address.State:
                case Types.Block.Name.Contact.Form.Input.Address.Zip:
                case Types.Block.Name.Contact.Form.Input.Email:
                case Types.Block.Name.Contact.Form.Input.Name:
                case Types.Block.Name.Contact.Form.Input.Phone:
                case Types.Block.Name.Contact.Form.Input.Subject:
                case Types.Block.Name.Footer.SubscribeForm.Input.Address.City:
                case Types.Block.Name.Footer.SubscribeForm.Input.Address.Country:
                case Types.Block.Name.Footer.SubscribeForm.Input.Address.Line1:
                case Types.Block.Name.Footer.SubscribeForm.Input.Address.Line2:
                case Types.Block.Name.Footer.SubscribeForm.Input.Address.State:
                case Types.Block.Name.Footer.SubscribeForm.Input.Address.Zip:
                case Types.Block.Name.Footer.SubscribeForm.Input.Email:
                case Types.Block.Name.Footer.SubscribeForm.Input.Name:
                case Types.Block.Name.Footer.SubscribeForm.Input.Phone:
                case Types.Block.Name.Header.SearchBar.Input.Search:
                case Types.Block.Name.InquireForm.Input.Address.City:
                case Types.Block.Name.InquireForm.Input.Address.Country:
                case Types.Block.Name.InquireForm.Input.Address.Line1:
                case Types.Block.Name.InquireForm.Input.Address.Line2:
                case Types.Block.Name.InquireForm.Input.Address.State:
                case Types.Block.Name.InquireForm.Input.Address.Zip:
                case Types.Block.Name.InquireForm.Input.Email:
                case Types.Block.Name.InquireForm.Input.Name:
                case Types.Block.Name.InquireForm.Input.Phone:
                case Types.Block.Name.OfferForm.Input.Email:
                case Types.Block.Name.OfferForm.Input.Name:
                case Types.Block.Name.OfferForm.Input.Phone:
                case Types.Block.Name.OfferForm.Input.PriceFixed:
                case Types.Block.Name.OfferForm.Input.PricePercent:
                case Types.Block.Name.PasswordForm.Input.Password:
                case Types.Block.Name.SubscribeForm.Input.Address.City:
                case Types.Block.Name.SubscribeForm.Input.Address.Country:
                case Types.Block.Name.SubscribeForm.Input.Address.Line1:
                case Types.Block.Name.SubscribeForm.Input.Address.Line2:
                case Types.Block.Name.SubscribeForm.Input.Address.State:
                case Types.Block.Name.SubscribeForm.Input.Address.Zip:
                case Types.Block.Name.SubscribeForm.Input.Email:
                case Types.Block.Name.SubscribeForm.Input.Name:
                case Types.Block.Name.SubscribeForm.Input.Phone:
                    Component = Input.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.Contact.Form.Input.Message:
                case Types.Block.Name.InquireForm.Input.Message:
                    Component = TextArea.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.Artist.Signup.SubmitButtonV1:         // DEPRECATED - use `Types.Block.Name.Artist.Signup.SubmitButtonV2`
                    Component = ArtistSignupSubmitButton.V1;
                // Intentional fallthrough
                case Types.Block.Name.Cart.PromoCode.SubmitButtonV1:        // DEPRECATED - use `Types.Block.Name.Cart.PromoCode.SubmitButtonV2`
                case Types.Block.Name.Cart.PurchaseButtonV1:                // DEPRECATED - use `Types.Block.Name.Cart.PurchaseButtonV2`
                case Types.Block.Name.Contact.Form.SubmitButtonV1:          // DEPRECATED - use `Types.Block.Name.Contact.Form.SubmitButtonV2`
                case Types.Block.Name.Footer.SubscribeForm.SubmitButtonV1:  // DEPRECATED - use `Types.Block.Name.Footer.SubscribeForm.SubmitButtonV2`
                case Types.Block.Name.Header.SearchBar.SubmitButtonV1:      // DEPRECATED - use `Types.Block.Name.Header.SearchBar.SubmitButtonV2`
                case Types.Block.Name.InquireForm.SubmitButtonV1:           // DEPRECATED - use `Types.Block.Name.InquireForm.SubmitButtonV2`
                case Types.Block.Name.OfferForm.SubmitButtonV1:             // DEPRECATED - use `Types.Block.Name.OfferForm.SubmitButtonV2`
                case Types.Block.Name.SubscribeForm.SubmitButtonV1:         // DEPRECATED - use `Types.Block.Name.SubscribeForm.SubmitButtonV2`
                    if (!Component) {
                        Component = FormButton.V1;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Artist.Signup.SubmitButtonV2:
                    if (!Component) {
                        Component = ArtistSignupSubmitButton.V2;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Cart.PromoCode.SubmitButtonV2:
                case Types.Block.Name.Cart.PurchaseButtonV2:
                case Types.Block.Name.Contact.Form.SubmitButtonV2:
                case Types.Block.Name.Footer.SubscribeForm.SubmitButtonV2:
                case Types.Block.Name.Header.SearchBar.SubmitButtonV2:
                case Types.Block.Name.InquireForm.SubmitButtonV2:
                case Types.Block.Name.OfferForm.SubmitButtonV2:
                case Types.Block.Name.PasswordForm.SubmitButton:
                case Types.Block.Name.SubscribeForm.SubmitButtonV2:
                    if (!Component) {
                        Component = FormButton.V2;
                    }
                    data = providedData;
                    break;
                case Types.Block.Name.Artist.Signup.SuccessMessage:
                    Component = ArtistSignupSuccessMessage.Component;
                // Intentional fallthrough
                case Types.Block.Name.Contact.Form.SuccessMessage:
                case Types.Block.Name.Footer.SubscribeForm.SuccessMessage:
                case Types.Block.Name.InquireForm.SuccessMessage:
                case Types.Block.Name.OfferForm.SuccessMessage:
                case Types.Block.Name.SubscribeForm.SuccessMessage:
                    if (!Component) {
                        Component = SuccessMessage.Component;
                    }
                    data = providedData;
                    break;
                // INVENTORY
                case Types.Block.Name.Inventory.Cell.Image:
                case Types.Block.Name.Inventory.Cell.SlideshowImage:
                    Component = InventoryListCell.InventoryImage.Component;
                // Intentional fallthrough
                case Types.Block.Name.Inventory.Cell.Text:
                    if (!Component) {
                        Component = InventoryListCell.InventoryMeta.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Inventory.Button.InquireV1:   // DEPRECATED - use `Types.Block.Name.Inventory.Button.InquireV3`
                    if (!Component) {
                        Component = InquireButton.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Inventory.Button.OfferV1:     // DEPRECATED - use `Types.Block.Name.Inventory.Button.OfferV3`
                    if (!Component) {
                        Component = OfferButton.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Inventory.Button.PurchaseV1:  // DEPRECATED - use `Types.Block.Name.Inventory.Button.PurchaseV3`
                    if (!Component) {
                        Component = PurchaseButton.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Inventory.Button.InquireV2:   // DEPRECATED - use `Types.Block.Name.Inventory.Button.InquireV3`
                case Types.Block.Name.Inventory.Button.OfferV2:     // DEPRECATED - use `Types.Block.Name.Inventory.Button.OfferV3`
                case Types.Block.Name.Inventory.Button.PurchaseV2:  // DEPRECATED - use `Types.Block.Name.Inventory.Button.PurchaseV3`
                    if (!Component) {
                        Component = InventoryCTAButton.V1;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Inventory.Button.InquireV3:
                case Types.Block.Name.Inventory.Button.OfferV3:
                case Types.Block.Name.Inventory.Button.PurchaseV3:
                    if (!Component) {
                        Component = InventoryCTAButton.V2;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Inventory.ImageParallax:
                    if (!Component) {
                        Component = InventoryImageParallax.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.SearchResult.Cell.Text.Inventory:
                    if (!Component) {
                        Component = SearchResultCell.InventorySearchResultMeta.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.SearchResult.Cell.Image.Inventory:
                    if (!Component) {
                        Component = SearchResultCell.InventorySearchResultImage.Component;
                    }
                    data = providedData;
                    if (data && data.inventory) {
                        data = data.inventory;
                    }
                    break;
                case Types.Block.Name.Inventory.ControlsV1:
                case Types.Block.Name.Inventory.ControlsV2:
                    Component = InventoryControls.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.Inventory.Button.ArtistProfileV1: // DEPRECATED - use `Types.Block.Name.Inventory.Button.ArtistProfileV2`
                    Component = InventoryArtistProfileButton.V1;
                // Intentional fallthrough
                case Types.Block.Name.Inventory.Button.ArtistProfileV2:
                    if (!Component) {
                        Component = InventoryArtistProfileButton.V2;
                    }
                    if (providedData && providedData.inventory) {
                        data = providedData.inventory.artist;
                    }
                    break;
                case Types.Block.Name.Inventory.EditionSets:
                    Component = EditionSets.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.Inventory.Image:
                    Component = InventoryMeta.Image.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.Inventory.Meta.Legacy:
                    Component = InventoryMeta.Legacy.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.Inventory.Text:
                    Component = InventoryMeta.Tokenized.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.Artist.Inventory.ListV1:
                case Types.Block.Name.Inventory.ListV1:
                case Types.Block.Name.Inventory.RelatedV1:
                case Types.Block.Name.Show.Inventory.ListV1:
                    Component = InventoryListV1.Component;
                // Intentional fallthrough
                case Types.Block.Name.Artist.Inventory.ListV2:
                case Types.Block.Name.Inventory.ListV2:
                case Types.Block.Name.Inventory.RelatedV2:
                case Types.Block.Name.Show.Inventory.ListV2:
                    if (!Component) {
                        Component = InventoryListV2.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Artist.Inventory.ListV3:
                case Types.Block.Name.Inventory.ListV3:
                case Types.Block.Name.Inventory.RelatedV3:
                case Types.Block.Name.Show.Inventory.ListV3:
                    if (!Component) {
                        Component = InventoryListV3.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Artist.Inventory.ListV4:
                case Types.Block.Name.Inventory.ListV4:
                case Types.Block.Name.Inventory.Presentation.List:
                case Types.Block.Name.Inventory.RelatedV4:
                case Types.Block.Name.Show.Inventory.ListV4:
                    if (!Component) {
                        Component = InventoryListV4.Component;
                    }
                    context = {};
                    if (providedData) {
                        if (providedData.artist) {
                            context.artistId = providedData.artist.id;
                        }
                        if (providedData.inventory) {
                            context.inventoryId = providedData.inventory.id;
                        }
                        if (providedData.show) {
                            context.listId = providedData.show.id;
                        }
                        jsonLD = providedData.inventoryJsonLD;
                    }
                    if (block && block.config) {
                        if (block.config.block) {
                            context.source = block.config.block.source;
                            context.status = block.config.block.status;
                            if ((context.source == 3 || context.status == 3) && block.config.block.list) {
                                context.listId = block.config.block.list.listId;
                            } else if (context.source == 6 || context.status == 6) {
                                context.tags = block.config.block.tags;
                            }

                            // Set in context, even though read from blockConfig => Helps inform builder updates that require data fetch
                            context.maxLimit = block.config.block.maxLimit;
                            context.order = block.config.block.order;
                            context.subType = block.config.block.subType;
                            context.type = block.config.block.type;
                        }
                        if (block.config.inventory) {
                            context.lastUpdated = block.config.inventory.lastUpdated;
                        }
                    }
                    break;
                case Types.Block.Name.Inventory.RecentlyViewed.Cell.Image:
                    Component = RecentlyViewedCell.Image.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.Inventory.RecentlyViewed.Cell.Text:
                    Component = RecentlyViewedCell.Meta.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.Inventory.RecentlyViewed.List:
                    Component = RecentlyViewed.Component;
                    data = providedData;
                    break;
                // REPRESENTATIVE
                case Types.Block.Name.Representative.Cell.Text:
                    Component = RepresentativeListCell.RepresentativeMeta.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.Representative.List:
                    Component = RepresentativesList.Component;
                    break;
                // SEARCH
                case Types.Block.Name.SearchResult.Cell.Text.Blog:
                    Component = SearchResultCell.BlogSearchResultMeta.Component;
                // Intentional fallthrough
                case Types.Block.Name.SearchResult.Cell.Image.Blog:
                    if (!Component) {
                        Component = SearchResultCell.BlogSearchResultImage.Component;
                    }
                    data = providedData;
                    if (data && data.blog) {
                        data = data.blog;
                    }
                    break;
                case Types.Block.Name.SearchResult.List:
                    Component = SearchResults.List.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.SearchResult.Meta:
                    Component = SearchResults.Meta.Component;
                    data = providedData;
                    break;
                // SHOW
                case Types.Block.Name.InstallationPhotos:
                    if (!Component) {
                        Component = InstallationPhotos.Component;
                    }
                    data = providedData;
                    if (data && data.show) {
                        data = data.show.photos;
                    }
                    break;
                case Types.Block.Name.SearchResult.Cell.Text.Show:
                    Component = SearchResultCell.ShowSearchResultMeta.Component;
                // Intentional fallthrough
                case Types.Block.Name.SearchResult.Cell.Image.Show:
                    if (!Component) {
                        Component = SearchResultCell.ShowSearchResultImage.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Show.Cell.DetailButtonV1: // DEPRECATED - use `Types.Block.Name.Show.Cell.DetailButtonV3`
                    if (!Component) {
                        Component = ShowListCell.ShowDetailButtonV1.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Show.Cell.DetailButtonV2: // DEPRECATED - use `Types.Block.Name.Show.Cell.DetailButtonV3`
                    if (!Component) {
                        Component = ShowListCell.ShowDetailButtonV2.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Show.Cell.DetailButtonV3:
                    if (!Component) {
                        Component = ShowListCell.ShowDetailButtonV3.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Show.Cell.Image:
                    if (!Component) {
                        Component = ShowListCell.ShowImage.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Show.Cell.Text:
                    if (!Component) {
                        Component = ShowListCell.ShowMeta.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Show.Description:
                    if (!Component) {
                        Component = ShowMeta.Tokenized.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Show.ImageParallax:
                    if (!Component) {
                        Component = ShowImageParallax.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Show.TitleV2: // DEPRECATED - use `Types.Block.Name.Show.TitleV1`
                    if (!Component) {
                        Component = ShowMeta.TitleV2.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Show.TitleV1:
                    if (!Component) {
                        Component = ShowMeta.TitleV1.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Show.ImageV1: // DEPRECATED - use `Types.Block.Name.Show.ImageV2`
                    if (!Component) {
                        Component = ShowMeta.ImageV1.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Show.ImageV2:
                    if (!Component) {
                        Component = ShowMeta.ImageV2.Component;
                    }
                    data = providedData;
                    if (data && data.show) {
                        data = data.show;
                    }
                    break;
                case Types.Block.Name.Artist.Show.List.Parallax:
                case Types.Block.Name.Show.List.Parallax:
                    Component = ShowsListParallax.Component;
                // Intentional fallthrough
                case Types.Block.Name.Artist.Show.List.Slideshow:
                case Types.Block.Name.Artist.Show.List.SlideshowFullBackground:
                case Types.Block.Name.Show.List.Slideshow:
                case Types.Block.Name.Show.List.SlideshowFullBackground:
                    if (!Component) {
                        Component = ShowsListSlideshow.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Artist.Show.List.Grid:
                case Types.Block.Name.Show.List.Grid:
                    if (!Component) {
                        Component = ShowsListGrid.Component;
                    }
                    context = {};
                    if (providedData) {
                        if (providedData.artist) {
                            context.artistId = providedData.artist.id;
                        }
                        jsonLD = providedData.showsJsonLD;
                    }
                    if (block && block.config && block.config.block) {
                        context.status = block.config.block.status;

                        // Set in context, even though read from blockConfig => Helps inform builder updates that require data fetch
                        context.maxLimit = block.config.block.maxLimit;
                        context.tags = block.config.block.tags;
                    }
                    break;
                // COMMON
                case Types.Block.Name.Accordion:
                    Component = Accordion.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.ButtonV1:         // DEPRECATED - use `Types.Block.Name.ButtonV2`
                    Component = ButtonV1.Component;
                // Intentional fallthrough
                case Types.Block.Name.ButtonV2:         // DEPRECATED - use `Types.Block.Name.ButtonV2`
                    if (!Component) {
                        Component = ButtonV2.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.ButtonV3:
                case Types.Block.Name.CookiePolicy.Button.Accept:
                case Types.Block.Name.CookiePolicy.Button.Reject:
                case Types.Block.Name.InquireForm.CancelButton:
                    if (!Component) {
                        Component = ButtonV3.Component;
                    }
                    data = block;
                    break;
                case Types.Block.Name.Cart.RemoveButton:
                case Types.Block.Name.CloseButton:
                    Component = CloseButton.Component;
                    data = block;
                    break;
                case Types.Block.Name.Code:
                    Component = Code.Component;
                    data = block;
                    break;
                case Types.Block.Name.Columns:
                    Component = Columns.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.Contact.Address:
                    Component = Contact.Address.Component;
                    data = websiteConfig;
                    break;
                case Types.Block.Name.Contact.FormV1:   // DEPRECATED: - use `Types.Block.Name.Contact.Form.Container`
                    Component = Contact.ContactFormV1.Component;
                // Intentional fallthrough
                case Types.Block.Name.Contact.Form.Container:
                    if (!Component) {
                        Component = Contact.ContactFormV2.Component;
                    }
                    data = websiteConfig;
                    break;
                case Types.Block.Name.Contact.HoursV1:
                case Types.Block.Name.Contact.HoursV2:
                    Component = Contact.Hours.Component;
                    data = websiteConfig;
                    break;
                case Types.Block.Name.HeaderTextV2:
                    Component = HeaderText.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.HoverContent:
                    Component = HoverContent.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.ImageV1:          // DEPRECATED - use `Types.Block.Name.ImageV2`
                    Component = ImageV1.Component;
                // Intentional fallthrough
                case Types.Block.Name.ImageV2:
                    if (!Component) {
                        Component = ImageV2.Component;
                    }
                    data = providedData;
                    break;
                case Types.Block.Name.ImageGallery:
                    Component = ImageGallery.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.InquireForm.Container:
                    Component = InquireForm.Component;
                    data = websiteConfig;
                    break;
                case Types.Block.Name.Map:
                    Component = Map.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.ModalButtonNext:
                case Types.Block.Name.ModalButtonPrevious:
                    Component = ModalButton.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.OfferForm.Container:
                    Component = OfferForm.Component;
                    data = websiteConfig;
                    break;
                case Types.Block.Name.PasswordForm.Container:
                    Component = PasswordForm.Component;
                    data = websiteConfig;
                    break;
                case Types.Block.Name.PageTitleV2:      // DEPRECATED - use `Types.Block.Name.PageTitleV1`
                    Component = PageTitleV2.Component;
                // Intentional fallthrough
                case Types.Block.Name.PageTitleV1:
                    if (!Component) {
                        Component = PageTitleV1.Component;
                    }
                    data = providedData;
                    break;
                case Types.Block.Name.Parallax:
                    Component = Parallax.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.PurchasePopup.CartButtonV1:   // DEPRECATED - use `Types.Block.Name.PurchasePopup.CartButtonV2`
                    Component = CartButtonV1;
                // Intentional fallthrough
                case Types.Block.Name.PurchasePopup.CartButtonV2:
                    if (!Component) {
                        Component = CartButtonV2;
                    }
                    data = providedData;
                    break;
                case Types.Block.Name.PurchasePopup.ContinueButtonV1: // DEPRECATED - use `Types.Block.Name.PurchasePopup.ContinueButtonV2`
                    Component = ContinueButtonV1;
                // Intentional fallthrough
                case Types.Block.Name.PurchasePopup.ContinueButtonV2:
                    if (!Component) {
                        Component = ContinueButtonV2;
                    }
                    data = providedData;
                    break;
                case Types.Block.Name.PurchasePopup.DropDown.DimensionsV1:  // DEPRECATED - use `Types.Block.Name.PurchasePopup.DropDown.DimensionsV2`
                case Types.Block.Name.PurchasePopup.DropDown.MediaV1:       // DEPRECATED - use `Types.Block.Name.PurchasePopup.DropDown.MediaV2`
                case Types.Block.Name.PurchasePopup.DropDown.PriceV1:       // DEPRECATED - use `Types.Block.Name.PurchasePopup.DropDown.PriceV2`
                    Component = PurchasePopupDropDownV1;
                // Intentional fallthrough
                case Types.Block.Name.PurchasePopup.DropDown.DimensionsV2:
                case Types.Block.Name.PurchasePopup.DropDown.Framing:
                case Types.Block.Name.PurchasePopup.DropDown.MediaV2:
                case Types.Block.Name.PurchasePopup.DropDown.PriceV2:
                    if (!Component) {
                        Component = PurchasePopupDropDownV2;
                    }
                    data = providedData;
                    break;
                case Types.Block.Name.PurchasePopup.SubmitButtonV1: // DEPRECATED - use `Types.Block.Name.PurchasePopup.SubmitButtonV2`
                    Component = PurchasePopupSubmitButtonV1;
                // Intentional fallthrough
                case Types.Block.Name.PurchasePopup.SubmitButtonV2:
                    if (!Component) {
                        Component = PurchasePopupSubmitButtonV2;
                    }
                    data = providedData;
                    break;
                case Types.Block.Name.SignUpButtonV1:   // DEPRECATED - use `Types.Block.Name.SignUpButtonV3`
                    Component = SignUpButtonV1.Component;
                // Intentional fallthrough
                case Types.Block.Name.SignUpButtonV2:   // DEPRECATED - use `Types.Block.Name.SignUpButtonV3`
                    if (!Component) {
                        Component = SignUpButtonV2.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.SignUpButtonV3:
                    if (!Component) {
                        Component = SignUpButtonV3.Component;
                    }
                    data = providedData;
                    break;
                case Types.Block.Name.Slider.Carousel:
                    Component = Slider.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.Slider.Cell.Image:
                    Component = SliderCell.SlideImage.Component;
                    data = providedData;
                    break;
                case Types.Block.Name.SocialV1:         // DEPRECATED - use `Types.Block.Name.SocialV2`
                    Component = Social.V1.Component;
                // Intentional fallthrough
                case Types.Block.Name.SocialV2:
                    if (!Component) {
                        Component = Social.V2.Component;
                    }
                    data = providedData;
                    break;
                case Types.Block.Name.Artist.TabsV1:    // DEPRECATED - use `Types.Block.Name.Artist.TabsV3`
                case Types.Block.Name.Show.TabsV1:      // DEPRECATED - use `Types.Block.Name.Show.TabsV3`
                    Component = TabsV1.Component;
                // Intentional fallthrough
                case Types.Block.Name.Artist.TabsV2:
                case Types.Block.Name.Show.TabsV2:
                case Types.Block.Name.Tabs:
                    if (!Component) {
                        Component = TabsV2.Component;
                    }
                // Intentional fallthrough
                case Types.Block.Name.Artist.TabsV3:
                case Types.Block.Name.Show.TabsV3:
                case Types.Block.Name.TabsV3:
                    if (!Component) {
                        Component = TabsV3.Component;
                    }
                    data = providedData;
                    break;
                case Types.Block.Name.HeaderText:
                case Types.Block.Name.Text:
                    Component = Text.Component;
                    data = block;
                    break;
                case Types.Block.Name.Video:
                case Types.Block.Name.VideoHero:
                    Component = Video.Component;
                    data = providedData;
                    break;
                // FOOTER
                case Types.Block.Name.Footer.Address:   // DEPRECATED - use `Types.Block.Name.Contact.Address`
                    Component = Footer.Address.Component;
                    break;
                case Types.Block.Name.Footer.LogoV1:    // DEPRECATED - use `Types.Block.Name.Footer.LogoV2`
                    Component = HomeLinkV1.Component;
                    break;
                case Types.Block.Name.Footer.LogoV2:
                    Component = HomeLinkV2.Component;
                    break;
                case Types.Block.Name.Footer.QuickLinksV1:  // DEPRECATED - use `Types.Block.Name.Footer.QuickLinksV2`
                case Types.Block.Name.Footer.QuickLinksV2:
                    Component = Footer.QuickLinks.Component;
                    break;
                case Types.Block.Name.Footer.Social:    // DEPRECATED - use `Types.Block.Name.Social`
                    Component = Footer.Social.Component;
                    break;
                case Types.Block.Name.Footer.SubscribeFormV1:   // DEPRECATED - use `Types.Block.Name.Footer.Subscribe.Container`    
                    Component = SubscribeFormV1.Component;
                // Intentional fallthrough
                case Types.Block.Name.Footer.SubscribeForm.Container:
                    if (!Component) {
                        Component = SubscribeFormV2.Footer;
                    }
                // Intentional fallthrough
                case Types.Block.Name.SubscribeForm.Container:
                    if (!Component) {
                        Component = SubscribeFormV2.CustomPage;
                        data = providedData;
                    }
                    break;
                // HEADER
                case Types.Block.Name.Header.CartLink:
                    Component = Header.CartLink.Component;
                    break;
                case Types.Block.Name.Header.LogoV1:    // DEPRECATED - use `Types.Block.Name.Header.LogoV2`
                    Component = HomeLinkV1.Component;
                    break;
                case Types.Block.Name.Header.LogoV2:
                    Component = HomeLinkV2.Component;
                    break;
                case Types.Block.Name.Header.MenuItemsV1:   // DEPRECATED - use `Types.Block.Name.Header.MenuItemsV2`
                case Types.Block.Name.Header.MenuItemsV2:
                    Component = Header.MenuItems.Component;
                    break;
                case Types.Block.Name.Header.MobileToggle:
                    Component = Header.MobileToggle.Component;
                    break;
                case Types.Block.Name.Header.SearchToggleV1:   // DEPRECATED - use `Types.Block.Name.Header.SearchToggleV2`
                case Types.Block.Name.Header.SearchToggleV2:
                    Component = Header.SearchToggle.Component;
                    break;
                // LEGACY PAGES
                case 'blog':
                case PageType.Content.Blog:
                    Component = BlogPost;
                    if (providedData) {
                        data = providedData.blog;
                    }
                    break;
                case 'notFound':
                    Component = NotFound;
                    break;
                default:
                    return null;
            }
            switch (pageType) {
                case PageType.ArtistDetail:
                case PageType.ExhibitionDetail:
                case PageType.InventoryDetail:
                case PageType.InventoryDetailModal:
                    jsonLD = undefined;
                    break;
            }
            return { component: Component, context, data, jsonLD };
        },
        getDisplay: function (blockType, context, config) {
            if (!blockType) {
                return 'Unknown Block';
            }
            if (Types.Block.isCustomGroupBlock(blockType.value)) {
                return "Custom";
            }
            if (Types.Block.isCustomTemplateBlock(blockType.value)) {
                return "Composition";
            }
            switch (blockType.value) {
                case 0:
                    return "Custom";
                case 1:
                case Types.Block.Name.Artist.ListV2:
                    return "Artists List";
                case Types.Block.Name.Artist.List:
                    return "Artists List (Deprecated)";
                case 2:
                case Types.Block.Name.Inventory.ListV4:
                case Types.Block.Name.Inventory.Presentation.List:
                    return "Inventory List";
                case Types.Block.Name.Inventory.ListV1:
                case Types.Block.Name.Inventory.ListV2:
                case Types.Block.Name.Inventory.ListV3:
                    return "Inventory List (Deprecated)";
                case 3:
                case Types.Block.Name.Show.List.Grid:
                    return "Exhibitions List";
                case 4:
                    return "Contact Form";
                case 5:
                case Types.Block.Name.Slider.Carousel:
                    return "Slider";
                case 6:
                case Types.Block.Name.Artist.Inventory.ListV4:
                    return "Artist Inventory List";
                case Types.Block.Name.Artist.Inventory.ListV1:
                case Types.Block.Name.Artist.Inventory.ListV2:
                case Types.Block.Name.Artist.Inventory.ListV3:
                    return "Artist Inventory List (Deprecated)";
                case 7:
                case 18: // Inventory Artist
                case Types.Block.Name.Artist.Bio.Group:
                case Types.Block.Name.Artist.Bio.Text:
                case Types.Block.Name.Artist.CV:
                case Types.Block.Name.Inventory.Artist.Bio.Group:
                case Types.Block.Name.Inventory.Artist.Bio.Text:
                    if (config && config.userType == 1) {
                        return "Meta Text";
                    }
                    return "Artist Meta Text";
                case 8:
                case 28: // Inventory Artist
                case Types.Block.Name.Artist.Cell.Text:
                case Types.Block.Name.Artist.NameV1:
                case Types.Block.Name.Inventory.Artist.NameV1:
                    return "Artist Name";
                case Types.Block.Name.Artist.NameV2:
                case Types.Block.Name.Inventory.Artist.NameV2:
                    return "Artist Name (Deprecated)";
                case 9:
                case Types.Block.Name.Artist.Bio.Tabbed:
                    return "Tabbed Artist Biography";
                case 10:
                case Types.Block.Name.Show.Artist.ListV2:
                    return "Exhibition Artists List";
                case Types.Block.Name.Show.Artist.List:
                    return "Exhibition Artists List (Deprecated)";
                case Types.Block.Name.Show.Inventory.ListV4:
                    return "Exhibition Inventory List";
                case Types.Block.Name.Show.Inventory.ListV1:
                case Types.Block.Name.Show.Inventory.ListV2:
                case Types.Block.Name.Show.Inventory.ListV3:
                    return "Exhibition Inventory List (Deprecated)";
                case 11:
                    return "Exhibition Description";
                case 12:
                    return "Exhibition Title";
                case 13:
                case Types.Block.Name.Inventory.Cell.Text:
                case Types.Block.Name.Inventory.Meta.Legacy:
                    return "Inventory Meta";
                case 14:
                case Types.Block.Name.InstallationPhotos:
                    return "Installation Photos";
                case 15:
                case Types.Block.Name.Blog.List:
                    return "Blogs List";
                case 16:
                case Types.Block.Name.Inventory.RelatedV4:
                    return "Related Inventory List";
                case Types.Block.Name.Inventory.RelatedV1:
                case Types.Block.Name.Inventory.RelatedV2:
                case Types.Block.Name.Inventory.RelatedV3:
                    return "Related Inventory List (Deprecated)";
                case 17:
                case Types.Block.Name.Artist.Signup.Container:
                    return "Artist Signup";
                case Types.Block.Name.Artist.SignupV1:
                    return "Artist Signup (Deprecated)";
                case 19:
                case Types.Block.Name.Artist.Blog.List:
                    return "Artist Blogs List";
                case 20:
                case Types.Block.Name.Show.Blog.List:
                    return "Exhibition Blogs List";
                case 21:
                case Types.Block.Name.Inventory.Blog.List:
                    return "Inventory Blogs List";
                case 22:
                case Types.Block.Name.Artist.Media.List:
                    return "Artist Media List";
                case 23:
                case Types.Block.Name.Show.Media.List:
                    return "Exhibition Media List";
                case 24:
                case Types.Block.Name.Inventory.Media.List:
                    return "Inventory Media List";
                case 25:
                case Types.Block.Name.Artist.TabsV3:
                case Types.Block.Name.Show.TabsV3:
                case Types.Block.Name.TabsV3:
                    return "Tabs";
                case Types.Block.Name.Artist.TabsV1:
                case Types.Block.Name.Artist.TabsV2:
                case Types.Block.Name.Show.TabsV1:
                case Types.Block.Name.Show.TabsV2:
                case Types.Block.Name.Tabs:
                    return "Tabs (Deprecated)";
                case 26:
                case Types.Block.Name.Artist.Show.List.Grid:
                    return "Artist Exhibitions List";
                case 27:
                case Types.Block.Name.Media.List:
                    return "Media List";
                case 29:
                case Types.Block.Name.ImageGallery:
                    return "Image Gallery";
                case 30:
                case Types.Block.Name.Show.List.Parallax:
                    return "Exhibitions Parallax";
                case Types.Block.Name.Artist.Show.List.Parallax:
                    return "Artist Exhibitions Parallax";
                case Types.Block.Name.Artist.Show.List.Slideshow:
                case Types.Block.Name.Artist.Show.List.SlideshowFullBackground:
                    return "Artist Exhibitions Slideshow";
                case Types.Block.Name.Artist.Signup.Input.Email:
                case Types.Block.Name.Artist.Signup.Input.Name:
                    return "Signup Form Input";
                case Types.Block.Name.Artist.Cell.Image:
                case Types.Block.Name.Artist.Cell.ImageHover:
                case Types.Block.Name.Artist.ImageV2:
                case Types.Block.Name.Inventory.Artist.ImageV2:
                case Types.Block.Name.SearchResult.Cell.Image.Artist:
                    if (config && config.userType == 1) {
                        return "Profile Image";
                    }
                    return "Artist Image"
                case Types.Block.Name.Artist.ImageV1:
                case Types.Block.Name.Inventory.Artist.ImageV1:
                    return "Artist Image (Deprecated)";
                case Types.Block.Name.Artist.ImageParallax:
                    return "Artist Image Parallax";
                case Types.Block.Name.SearchResult.Cell.Text.Artist:
                    return "Artist Meta Text"
                case Types.Block.Name.Blog.Cell.Image:
                case Types.Block.Name.SearchResult.Cell.Image.Blog:
                    return "Blog Image";
                case Types.Block.Name.Blog.Cell.Text:
                case Types.Block.Name.Blog.Meta:
                case Types.Block.Name.Blog.TitleV2:
                case Types.Block.Name.SearchResult.Cell.Text.Blog:
                    return "Blog Meta Text";
                case Types.Block.Name.Blog.ImageParallax:
                    return "Blog Image Parallax"
                case Types.Block.Name.Blog.TitleV1:
                    return "Blog Title (Deprecated)";
                case Types.Block.Name.ImageV2:
                    return "Image";
                case Types.Block.Name.ImageV1:
                    return "Image (Deprecated)";
                case Types.Block.Name.Inventory.ControlsV2:
                    return "Inventory Controls";
                case Types.Block.Name.Inventory.ControlsV1:
                    return "Inventory Controls (Deprecated)";
                case Types.Block.Name.Inventory.EditionSets:
                    return "Edition Sets";
                case Types.Block.Name.Inventory.Cell.Image:
                    if (context == PageType.Content.InventoryCell.SlideshowV2) {
                        return "Inventory Image (Deprecated)";
                    }
                // Intentional fallthrough
                case Types.Block.Name.Inventory.Cell.SlideshowImage:
                case Types.Block.Name.Inventory.Image:
                case Types.Block.Name.Inventory.RecentlyViewed.Cell.Image:
                case Types.Block.Name.SearchResult.Cell.Image.Inventory:
                    return "Inventory Image";
                case Types.Block.Name.Inventory.ImageParallax:
                    return "Inventory Image Parallax";
                case Types.Block.Name.Inventory.Text:
                case Types.Block.Name.Inventory.RecentlyViewed.Cell.Text:
                case Types.Block.Name.SearchResult.Cell.Text.Inventory:
                    return "Inventory Meta Text";
                case Types.Block.Name.Inventory.Meta.Group:
                    return "Inventory Meta";
                case Types.Block.Name.Inventory.Button.ArtistProfileV1:
                    return "Inventory Artist Profile Button (Deprecated)";
                case Types.Block.Name.Inventory.Button.ArtistProfileV2:
                    return "Inventory Artist Profile Button";
                case Types.Block.Name.Inventory.Button.InquireV2:
                case Types.Block.Name.Inventory.Button.OfferV2:
                case Types.Block.Name.Inventory.Button.PurchaseV2:
                    return "Inventory CTA Button (Deprecated)";
                case Types.Block.Name.Inventory.Button.InquireV3:
                case Types.Block.Name.Inventory.Button.OfferV3:
                case Types.Block.Name.Inventory.Button.PurchaseV3:
                    return "Inventory CTA Button";
                case Types.Block.Name.Inventory.Button.InquireV1:
                    return "Inquire Button (Deprecated)";
                case Types.Block.Name.Inventory.Button.OfferV1:
                    return "Offer Button (Deprecated)";
                case Types.Block.Name.Inventory.Button.PurchaseV1:
                    return "Purchase Button (Deprecated)";
                case Types.Block.Name.Inventory.RecentlyViewed.List:
                    return "Recently Viewed";
                case Types.Block.Name.Show.Cell.DetailButtonV3:
                    return "Exhibition Detail Button";
                case Types.Block.Name.Show.Cell.DetailButtonV1:
                case Types.Block.Name.Show.Cell.DetailButtonV2:
                    return "Exhibition Detail Button (Deprecated)";
                case Types.Block.Name.SearchResult.Cell.Image.Show:
                case Types.Block.Name.Show.Cell.Image:
                case Types.Block.Name.Show.ImageV2:
                    return "Exhibition Image";
                case Types.Block.Name.Show.ImageV1:
                    return "Exhibition Image (Deprecated)";
                case Types.Block.Name.SearchResult.Cell.Text.Show:
                case Types.Block.Name.Show.Description:
                case Types.Block.Name.Show.Cell.Text:
                    return "Exhibition Meta Text";
                case Types.Block.Name.Show.ImageParallax:
                    return "Exhibition Image Parallax";
                case Types.Block.Name.Show.List.Slideshow:
                case Types.Block.Name.Show.List.SlideshowFullBackground:
                    return "Exhibitions Slideshow";
                case Types.Block.Name.Show.TitleV1:
                    return "Exhibition Title";
                case Types.Block.Name.Show.TitleV2:
                    return "Exhibition Title (Deprecated)";
                case Types.Block.Name.Accordion:
                    return "Accordion";
                case 'blog':
                    return "Blog Post";
                case 'cart':
                    return "Cart";
                case Types.Block.Name.ButtonV1:
                case Types.Block.Name.ButtonV2:
                    return "Button (Deprecated)";
                case Types.Block.Name.ButtonV3:
                case Types.Block.Name.CookiePolicy.Button.Accept:
                case Types.Block.Name.CookiePolicy.Button.Reject:
                    return "Button";
                case Types.Block.Name.Cart.ApplePayButton:
                    return "BLOCK REMOVED!";
                case Types.Block.Name.Cart.CardForm.Container:
                    return "Card Form";
                case Types.Block.Name.Cart.CardFormV1:
                    return "Card Form (Deprecated)";
                case Types.Block.Name.Cart.CardForm.SameAddressCheckbox:
                    return "Same Address Toggle";
                case Types.Block.Name.Artist.Signup.ErrorMessage:
                case Types.Block.Name.Cart.CardForm.ErrorMessage:
                case Types.Block.Name.Cart.PromoCode.ErrorMessage:
                case Types.Block.Name.Contact.Form.ErrorMessage:
                case Types.Block.Name.Footer.SubscribeForm.ErrorMessage:
                case Types.Block.Name.InquireForm.ErrorMessage:
                case Types.Block.Name.OfferForm.ErrorMessage:
                case Types.Block.Name.PasswordForm.ErrorMessage:
                case Types.Block.Name.SubscribeForm.ErrorMessage:
                    return "Error Message";
                case Types.Block.Name.Artist.Signup.SuccessMessage:
                case Types.Block.Name.Contact.Form.SuccessMessage:
                case Types.Block.Name.Footer.SubscribeForm.SuccessMessage:
                case Types.Block.Name.InquireForm.SuccessMessage:
                case Types.Block.Name.OfferForm.SuccessMessage:
                case Types.Block.Name.SubscribeForm.SuccessMessage:
                    return "Success Message";
                case Types.Block.Name.Cart.CardForm.Input.BillingAddress.AddressLine1:
                case Types.Block.Name.Cart.CardForm.Input.BillingAddress.AddressLine2:
                case Types.Block.Name.Cart.CardForm.Input.BillingAddress.City:
                case Types.Block.Name.Cart.CardForm.Input.BillingAddress.Country:
                case Types.Block.Name.Cart.CardForm.Input.BillingAddress.State:
                case Types.Block.Name.Cart.CardForm.Input.BillingAddress.Zip:
                case Types.Block.Name.Cart.CardForm.Input.Email:
                case Types.Block.Name.Cart.CardForm.Input.FirstName:
                case Types.Block.Name.Cart.CardForm.Input.LastName:
                case Types.Block.Name.Cart.CardForm.Input.Notes:
                case Types.Block.Name.Cart.CardForm.Input.Phone:
                case Types.Block.Name.Cart.CardForm.Input.ShippingAddress.AddressLine1:
                case Types.Block.Name.Cart.CardForm.Input.ShippingAddress.AddressLine2:
                case Types.Block.Name.Cart.CardForm.Input.ShippingAddress.City:
                case Types.Block.Name.Cart.CardForm.Input.ShippingAddress.Country:
                case Types.Block.Name.Cart.CardForm.Input.ShippingAddress.State:
                case Types.Block.Name.Cart.CardForm.Input.ShippingAddress.Zip:
                    return "Card Form Input";
                case Types.Block.Name.Cart.CardForm.Input.CardNumber:
                case Types.Block.Name.Cart.CardForm.Input.ExpirationDate:
                case Types.Block.Name.Cart.CardForm.Input.SecurityCode:
                    return "BLOCK REMOVED!";
                case Types.Block.Name.Cart.LineItem.Cell.InventoryLineItemQuantityInput:
                    return "Quantity Input"
                case Types.Block.Name.Cart.LineItem.Cell.PromoCodeLineItemText:
                    return "Promo Code Meta Text"
                case Types.Block.Name.Cart.LineItem.List:
                    return "Line Items";
                case Types.Block.Name.Cart.PromoCode.Container:
                    return "Promo Code";
                case Types.Block.Name.Cart.PromoCodeV1:
                    return "Promo Code (Deprecated)";
                case Types.Block.Name.Cart.PromoCode.Input.Code:
                    return "Code Input";
                case Types.Block.Name.InquireForm.CancelButton:
                    return "Cancel Button";
                case Types.Block.Name.Artist.Signup.SubmitButtonV1:
                case Types.Block.Name.Cart.PromoCode.SubmitButtonV1:
                case Types.Block.Name.Contact.Form.SubmitButtonV1:
                case Types.Block.Name.Footer.SubscribeForm.SubmitButtonV1:
                case Types.Block.Name.Header.SearchBar.SubmitButtonV1:
                case Types.Block.Name.InquireForm.SubmitButtonV1:
                case Types.Block.Name.OfferForm.SubmitButtonV1:
                case Types.Block.Name.PurchasePopup.SubmitButtonV1:
                case Types.Block.Name.SubscribeForm.SubmitButtonV1:
                    return "Submit Button (Deprecated)";
                case Types.Block.Name.Artist.Signup.SubmitButtonV2:
                case Types.Block.Name.Cart.PromoCode.SubmitButtonV2:
                case Types.Block.Name.Contact.Form.SubmitButtonV2:
                case Types.Block.Name.Footer.SubscribeForm.SubmitButtonV2:
                case Types.Block.Name.Header.SearchBar.SubmitButtonV2:
                case Types.Block.Name.InquireForm.SubmitButtonV2:
                case Types.Block.Name.OfferForm.SubmitButtonV2:
                case Types.Block.Name.PasswordForm.SubmitButton:
                case Types.Block.Name.PurchasePopup.SubmitButtonV2:
                case Types.Block.Name.SubscribeForm.SubmitButtonV2:
                    return "Submit Button";
                case Types.Block.Name.Cart.PurchaseButtonV1:
                    return "Purchase Button (Deprecated)";
                case Types.Block.Name.Cart.PurchaseButtonV2:
                    return "Purchase Button";
                case Types.Block.Name.Cart.RemoveButton:
                    return "Remove Button";
                case Types.Block.Name.Cart.Shipping:
                case Types.Block.Name.Cart.Subtotal:
                case Types.Block.Name.Cart.Tax:
                    return "Cart Total";
                case Types.Block.Name.Cart.StripeElements:
                    return "Stripe Card Form";
                case Types.Block.Name.CloseButton:
                    return "Close Button";
                case Types.Block.Name.Code:
                    return "Code";
                case Types.Block.Name.Columns:
                    return "Columns";
                case Types.Block.Name.Contact.Address:
                    return "Address";
                case Types.Block.Name.Contact.Form.Container:
                    return "Contact Form";
                case Types.Block.Name.Contact.FormV1:
                    return "Contact Form (Deprecated)";
                case Types.Block.Name.Contact.Form.Input.Address.City:
                case Types.Block.Name.Contact.Form.Input.Address.Country:
                case Types.Block.Name.Contact.Form.Input.Address.Line1:
                case Types.Block.Name.Contact.Form.Input.Address.Line2:
                case Types.Block.Name.Contact.Form.Input.Address.State:
                case Types.Block.Name.Contact.Form.Input.Address.Zip:
                case Types.Block.Name.Contact.Form.Input.Email:
                case Types.Block.Name.Contact.Form.Input.Name:
                case Types.Block.Name.Contact.Form.Input.Phone:
                case Types.Block.Name.Contact.Form.Input.Subject:
                    return "Contact Form Input";
                case Types.Block.Name.Contact.Form.Input.Message:
                case Types.Block.Name.InquireForm.Input.Message:
                    return "Message Input";
                case Types.Block.Name.Contact.HoursV2:
                    return "Hours";
                case Types.Block.Name.Contact.HoursV1:
                    return "Hours (Deprecated)";
                case Types.Block.Name.Footer.Address:
                    return "Company Address (Deprecated)";
                case Types.Block.Name.Footer.LogoV2:
                    return "Logo";
                case Types.Block.Name.Footer.LogoV1:
                    return "Logo (Deprecated)";
                case Types.Block.Name.Footer.QuickLinksV1:
                    return "Quick Links (Deprecated)";
                case Types.Block.Name.Footer.QuickLinksV2:
                    return "Quick Links";
                case Types.Block.Name.Footer.Social:
                case Types.Block.Name.SocialV1:
                    return "Social Links (Deprecated)";
                case Types.Block.Name.SocialV2:
                    return "Social Links";
                case Types.Block.Name.Footer.SubscribeFormV1:
                    return "Subscribe Form (Deprecated)";
                case Types.Block.Name.Footer.SubscribeForm.Container:
                case Types.Block.Name.SubscribeForm.Container:
                    return "Subscribe Form";
                case Types.Block.Name.Footer.SubscribeForm.Input.Address.City:
                case Types.Block.Name.Footer.SubscribeForm.Input.Address.Country:
                case Types.Block.Name.Footer.SubscribeForm.Input.Address.Line1:
                case Types.Block.Name.Footer.SubscribeForm.Input.Address.Line2:
                case Types.Block.Name.Footer.SubscribeForm.Input.Address.State:
                case Types.Block.Name.Footer.SubscribeForm.Input.Address.Zip:
                case Types.Block.Name.Footer.SubscribeForm.Input.Email:
                case Types.Block.Name.Footer.SubscribeForm.Input.Name:
                case Types.Block.Name.Footer.SubscribeForm.Input.Phone:
                case Types.Block.Name.SubscribeForm.Input.Address.City:
                case Types.Block.Name.SubscribeForm.Input.Address.Country:
                case Types.Block.Name.SubscribeForm.Input.Address.Line1:
                case Types.Block.Name.SubscribeForm.Input.Address.Line2:
                case Types.Block.Name.SubscribeForm.Input.Address.State:
                case Types.Block.Name.SubscribeForm.Input.Address.Zip:
                case Types.Block.Name.SubscribeForm.Input.Email:
                case Types.Block.Name.SubscribeForm.Input.Name:
                case Types.Block.Name.SubscribeForm.Input.Phone:
                    return "Subscribe Form Input";
                case Types.Block.Name.Header.CartLink:
                    return "Shopping Cart Button"
                case Types.Block.Name.Header.LogoV2:
                    return "Logo"
                case Types.Block.Name.Header.LogoV1:
                    return "Logo (Deprecated)";
                case Types.Block.Name.Header.MenuItemsV2:
                    return "Navigation Menu"
                case Types.Block.Name.Header.MenuItemsV1:
                    return "Navigation Menu (Deprecated)"
                case Types.Block.Name.Header.MobileToggle:
                    return "Navigation Menu Toggle"
                case Types.Block.Name.Header.SearchBar.Input.Search:
                    return "Search Input";
                case Types.Block.Name.Header.SearchToggleV2:
                    return "Search Toggle"
                case Types.Block.Name.Header.SearchToggleV1:
                    return "Search Toggle (Deprecated)"
                case Types.Block.Name.HeaderTextV2:
                    return "Header Text (Deprecated)";
                case Types.Block.Name.HorizontalRule:
                    return "Horizontal Line";
                case Types.Block.Name.HoverContent:
                    return "Hover Content";
                case Types.Block.Name.InquireForm.Container:
                    return "Inquire Form";
                case Types.Block.Name.InquireForm.Input.Address.City:
                case Types.Block.Name.InquireForm.Input.Address.Country:
                case Types.Block.Name.InquireForm.Input.Address.Line1:
                case Types.Block.Name.InquireForm.Input.Address.Line2:
                case Types.Block.Name.InquireForm.Input.Address.State:
                case Types.Block.Name.InquireForm.Input.Address.Zip:
                case Types.Block.Name.InquireForm.Input.Email:
                case Types.Block.Name.InquireForm.Input.Name:
                case Types.Block.Name.InquireForm.Input.Phone:
                case Types.Block.Name.InquireForm.Input.Subject:
                    return "Inquire Form Input";
                case Types.Block.Name.Map:
                    return "Map";
                case Types.Block.Name.ModalButtonNext:
                    return "Next Button";
                case Types.Block.Name.ModalButtonPrevious:
                    return "Previous Button";
                case Types.Block.Name.OfferForm.Container:
                    return "Offer Form";
                case Types.Block.Name.OfferForm.Input.Email:
                case Types.Block.Name.OfferForm.Input.Name:
                case Types.Block.Name.OfferForm.Input.Phone:
                case Types.Block.Name.OfferForm.Input.PriceFixed:
                case Types.Block.Name.OfferForm.Input.PricePercent:
                    return "Offer Form Input";
                case Types.Block.Name.PageTitleV1:
                    return "Page Title";
                case Types.Block.Name.PageTitleV2:
                    return "Page Title (Deprecated)";
                case Types.Block.Name.Parallax:
                    return "Parallax";
                case Types.Block.Name.PasswordForm.Container:
                    return "Password Form";
                case Types.Block.Name.PasswordForm.Input.Password:
                    return "Password Form Input";
                case Types.Block.Name.PurchasePopup.CartButtonV1:
                    return "Cart Button (Deprecated)";
                case Types.Block.Name.PurchasePopup.CartButtonV2:
                    return "Cart Button";
                case Types.Block.Name.PurchasePopup.ContinueButtonV1:
                    return "Continue Button (Deprecated)";
                case Types.Block.Name.PurchasePopup.ContinueButtonV2:
                    return "Continue Button";
                case Types.Block.Name.PurchasePopup.DropDown.DimensionsV1:
                case Types.Block.Name.PurchasePopup.DropDown.MediaV1:
                case Types.Block.Name.PurchasePopup.DropDown.PriceV1:
                    return "Purchase Popup Drop Down (Deprecated)";
                case Types.Block.Name.PurchasePopup.DropDown.DimensionsV2:
                case Types.Block.Name.PurchasePopup.DropDown.Framing:
                case Types.Block.Name.PurchasePopup.DropDown.MediaV2:
                case Types.Block.Name.PurchasePopup.DropDown.PriceV2:
                    return "Purchase Popup Drop Down";
                case Types.Block.Name.Representative.Cell.Text:
                    return "Gallery Meta Text";
                case Types.Block.Name.Representative.List:
                    return "Galleries List";
                case Types.Block.Name.SearchResult.List:
                    return "Search Results List";
                case Types.Block.Name.SearchResult.Meta:
                    return "Search Results Meta";
                case Types.Block.Name.SignUpButtonV3:
                    return "Sign Up Button";
                case Types.Block.Name.SignUpButtonV2:
                case Types.Block.Name.SignUpButtonV1:
                    return "Sign Up Button (Deprecated)";
                case Types.Block.Name.Slider.Cell.Image:
                    return "Slide Image";
                case Types.Block.Name.HeaderText:
                case Types.Block.Name.Text:
                    return "Text";
                case Types.Block.Name.Video:
                case Types.Block.Name.VideoHero:
                    return "Video";
                default:
                    return `Unknown block type value: ${blockType.value}`;
            }
        },
        getTokens: function (block, pageType, config) {
            if (!block) {
                return null;
            }
            switch (block.id) {
                case Types.Block.Name.Artist.Cell.Text:
                    return ArtistListCell.ArtistMeta.Tokens();
                case Types.Block.Name.Artist.NameV1:
                case Types.Block.Name.Artist.TabsV1:
                case Types.Block.Name.Artist.TabsV2:
                case Types.Block.Name.Artist.TabsV3:
                case Types.Block.Name.Inventory.Artist.NameV1:
                    return ArtistBio.NameV1.Tokens();
                case Types.Block.Name.Artist.NameV2:
                case Types.Block.Name.Inventory.Artist.NameV2:
                    return ArtistBio.NameV2.Tokens();
                case Types.Block.Name.Artist.Bio.Text:
                case Types.Block.Name.Artist.CV:
                case Types.Block.Name.Inventory.Artist.Bio.Text:
                    return ArtistBio.Tokenized.Tokens(pageType);
                case Types.Block.Name.Artist.Signup.SubmitButtonV1:
                case Types.Block.Name.Artist.Signup.SubmitButtonV2:
                case Types.Block.Name.Artist.Signup.SuccessMessage:
                    return ArtistSignupV2.Tokens();
                case Types.Block.Name.Blog.Cell.Text:
                    return BlogListCell.BlogMeta.Tokens();
                case Types.Block.Name.Blog.Meta:
                case Types.Block.Name.Blog.TitleV2:
                    return PostContent.Meta.Tokens();
                case Types.Block.Name.Blog.TitleV1:
                    return PostContent.Title.Tokens();
                case Types.Block.Name.Cart.LineItem.Cell.PromoCodeLineItemText:
                    return PromoCodeMeta.Tokens();
                case Types.Block.Name.Cart.Shipping:
                case Types.Block.Name.Cart.Subtotal:
                case Types.Block.Name.Cart.Tax:
                    return Cart.Total.Tokens();
                case Types.Block.Name.Contact.Address:
                    return Contact.Address.Tokens(pageType, config);
                case Types.Block.Name.Inventory.Button.ArtistProfileV1:
                case Types.Block.Name.Inventory.Button.ArtistProfileV2:
                    return InventoryArtistProfileButton.Tokens();
                case Types.Block.Name.Inventory.Cell.Text:
                    return InventoryListCell.InventoryMeta.Tokens();
                case Types.Block.Name.Inventory.EditionSets:
                    return EditionSets.Tokens();
                case Types.Block.Name.Inventory.RecentlyViewed.Cell.Text:
                    return RecentlyViewedCell.Meta.Tokens();
                case Types.Block.Name.Inventory.Text:
                    return InventoryMeta.Tokenized.Tokens();
                case Types.Block.Name.PageTitleV1:
                    return PageTitleV1.Tokens();
                case Types.Block.Name.PageTitleV2:
                    return PageTitleV2.Tokens();
                case Types.Block.Name.Representative.Cell.Text:
                    return RepresentativeListCell.RepresentativeMeta.Tokens();
                case Types.Block.Name.SearchResult.Cell.Text.Artist:
                    return SearchResultCell.ArtistSearchResultMeta.Tokens();
                case Types.Block.Name.SearchResult.Cell.Text.Blog:
                    return SearchResultCell.BlogSearchResultMeta.Tokens();
                case Types.Block.Name.SearchResult.Cell.Text.Inventory:
                    return SearchResultCell.InventorySearchResultMeta.Tokens();
                case Types.Block.Name.SearchResult.Cell.Text.Show:
                    return SearchResultCell.ShowSearchResultMeta.Tokens();
                case Types.Block.Name.SearchResult.Meta:
                    return SearchResults.Meta.Tokens();
                case Types.Block.Name.Show.Cell.Text:
                    return ShowListCell.ShowMeta.Tokens();
                case Types.Block.Name.Show.Description:
                case Types.Block.Name.Show.TabsV1:
                case Types.Block.Name.Show.TabsV2:
                case Types.Block.Name.Show.TabsV3:
                    return ShowMeta.Tokenized.Tokens();
                case Types.Block.Name.Show.TitleV1:
                    return ShowMeta.TitleV1.Tokens();
                case Types.Block.Name.Show.TitleV2:
                    return ShowMeta.TitleV2.Tokens();
            }
            return null;
        },
        isBlockAllowedInsideLayout(blockType, parentLayoutType) {
            const isCustomGroupBlock = Types.Block.isCustomGroupBlock(blockType)
            const isCustomTemplateBlock = Types.Block.isCustomTemplateBlock(blockType)
            switch (parentLayoutType) {
                case Types.Block.Name.Columns:
                    if (isCustomGroupBlock || isCustomTemplateBlock) {
                        return false;
                    }
                    switch (blockType) {
                        case Types.Block.Name.Artist.Bio.Group:
                        case Types.Block.Name.Artist.Bio.Tabbed:
                        case Types.Block.Name.Artist.Blog.List:
                        case Types.Block.Name.Artist.ImageParallax:
                        case Types.Block.Name.Artist.Inventory.ListV1:
                        case Types.Block.Name.Artist.Inventory.ListV2:
                        case Types.Block.Name.Artist.Inventory.ListV3:
                        case Types.Block.Name.Artist.Inventory.ListV4:
                        case Types.Block.Name.Artist.List:
                        case Types.Block.Name.Artist.ListV2:
                        case Types.Block.Name.Artist.Show.List.Slideshow:
                        case Types.Block.Name.Artist.Show.List.SlideshowFullBackground:
                        // case Types.Block.Name.Artist.Media.List:
                        case Types.Block.Name.Artist.TabsV1:
                        case Types.Block.Name.Artist.TabsV2:
                        case Types.Block.Name.Artist.TabsV3:
                        case Types.Block.Name.Blog.ImageParallax:
                        case Types.Block.Name.Blog.List:
                        case Types.Block.Name.Columns:
                        case Types.Block.Name.Inventory.Artist.Bio.Group:
                        case Types.Block.Name.Inventory.Blog.List:
                        case Types.Block.Name.Inventory.ImageParallax:
                        case Types.Block.Name.Inventory.ListV1:
                        case Types.Block.Name.Inventory.ListV2:
                        case Types.Block.Name.Inventory.ListV3:
                        case Types.Block.Name.Inventory.ListV4:
                        // case Types.Block.Name.Inventory.Media.List:
                        case Types.Block.Name.Inventory.Meta.Group:
                        case Types.Block.Name.Inventory.Presentation.List:
                        case Types.Block.Name.Inventory.RecentlyViewed.List:
                        case Types.Block.Name.Inventory.RelatedV1:
                        case Types.Block.Name.Inventory.RelatedV2:
                        case Types.Block.Name.Inventory.RelatedV3:
                        case Types.Block.Name.Inventory.RelatedV4:
                        // case Types.Block.Name.Media.List:
                        case Types.Block.Name.Parallax:
                        case Types.Block.Name.Representative.List:
                        case Types.Block.Name.Show.Artist.List:
                        case Types.Block.Name.Show.Artist.ListV2:
                        case Types.Block.Name.Show.Blog.List:
                        case Types.Block.Name.Show.ImageParallax:
                        case Types.Block.Name.Show.Inventory.ListV1:
                        case Types.Block.Name.Show.Inventory.ListV2:
                        case Types.Block.Name.Show.Inventory.ListV3:
                        case Types.Block.Name.Show.Inventory.ListV4:
                        case Types.Block.Name.Show.List.Grid:
                        case Types.Block.Name.Show.List.Parallax:
                        case Types.Block.Name.Show.List.Slideshow:
                        case Types.Block.Name.Show.List.SlideshowFullBackground:
                        // case Types.Block.Name.Show.Media.List:
                        case Types.Block.Name.Show.TabsV1:
                        case Types.Block.Name.Show.TabsV2:
                        case Types.Block.Name.Show.TabsV3:
                        case Types.Block.Name.Slider.Carousel:
                        case Types.Block.Name.Tabs:
                        case Types.Block.Name.TabsV3:
                            return false;
                    }
                    break;
                case Types.Block.Name.HoverContent:
                    if (isCustomGroupBlock || isCustomTemplateBlock) {
                        return false;
                    }
                    switch (blockType) {
                        case Types.Block.Name.Artist.Bio.Group:
                        case Types.Block.Name.Artist.Bio.Tabbed:
                        case Types.Block.Name.Artist.Blog.List:
                        case Types.Block.Name.Artist.Cell.ImageHover:
                        case Types.Block.Name.Artist.ImageParallax:
                        case Types.Block.Name.Artist.Inventory.ListV1:
                        case Types.Block.Name.Artist.Inventory.ListV2:
                        case Types.Block.Name.Artist.Inventory.ListV3:
                        case Types.Block.Name.Artist.Inventory.ListV4:
                        case Types.Block.Name.Artist.List:
                        case Types.Block.Name.Artist.ListV2:
                        case Types.Block.Name.Artist.Media.List:
                        case Types.Block.Name.Artist.Show.List.Slideshow:
                        case Types.Block.Name.Artist.Show.List.SlideshowFullBackground:
                        case Types.Block.Name.Artist.TabsV1:
                        case Types.Block.Name.Artist.TabsV2:
                        case Types.Block.Name.Artist.TabsV3:
                        case Types.Block.Name.Blog.ImageParallax:
                        case Types.Block.Name.Blog.List:
                        case Types.Block.Name.Columns:
                        case Types.Block.Name.HoverContent:
                        case Types.Block.Name.ImageGallery:
                        case Types.Block.Name.InstallationPhotos:
                        case Types.Block.Name.Inventory.Artist.Bio.Group:
                        case Types.Block.Name.Inventory.Blog.List:
                        case Types.Block.Name.Inventory.ImageParallax:
                        case Types.Block.Name.Inventory.ListV1:
                        case Types.Block.Name.Inventory.ListV2:
                        case Types.Block.Name.Inventory.ListV3:
                        case Types.Block.Name.Inventory.ListV4:
                        case Types.Block.Name.Inventory.Media.List:
                        case Types.Block.Name.Inventory.Meta.Group:
                        case Types.Block.Name.Inventory.Presentation.List:
                        case Types.Block.Name.Inventory.RecentlyViewed.List:
                        case Types.Block.Name.Inventory.RelatedV1:
                        case Types.Block.Name.Inventory.RelatedV2:
                        case Types.Block.Name.Inventory.RelatedV3:
                        case Types.Block.Name.Inventory.RelatedV4:
                        case Types.Block.Name.Media.List:
                        case Types.Block.Name.Parallax:
                        case Types.Block.Name.Representative.List:
                        case Types.Block.Name.Show.Artist.List:
                        case Types.Block.Name.Show.Artist.ListV2:
                        case Types.Block.Name.Show.Blog.List:
                        case Types.Block.Name.Show.ImageParallax:
                        case Types.Block.Name.Show.Inventory.ListV1:
                        case Types.Block.Name.Show.Inventory.ListV2:
                        case Types.Block.Name.Show.Inventory.ListV3:
                        case Types.Block.Name.Show.Inventory.ListV4:
                        case Types.Block.Name.Show.List.Grid:
                        case Types.Block.Name.Show.List.Parallax:
                        case Types.Block.Name.Show.List.Slideshow:
                        case Types.Block.Name.Show.List.SlideshowFullBackground:
                        case Types.Block.Name.Show.Media.List:
                        case Types.Block.Name.Show.TabsV1:
                        case Types.Block.Name.Show.TabsV2:
                        case Types.Block.Name.Show.TabsV3:
                        case Types.Block.Name.Slider.Carousel:
                        case Types.Block.Name.SocialV1:
                        case Types.Block.Name.SocialV2:
                        case Types.Block.Name.Tabs:
                        case Types.Block.Name.TabsV3:
                            return false;
                    }
                    break;
            }
            return true;
        },
        _checkTagsInJsonLD: (jsonLD, tags) => {
            return true;

            if (!jsonLD) {
                return false;
            }
            if (!tags) {
                return jsonLD.length > 0;
            }
            for (let i = 0; i < jsonLD.length; i++) {
                const itemTags = new Set(jsonLD[i].tags);
                if (itemTags.has(tags)) {
                    return true;
                }
            }
            return false;
        },
        isComponentEmpty: function (block, providedData, config) {
            if (!block || !block.type) {
                return null;
            }
            const componentState = { id: block.id, visible: true };
            switch (block.type.value) {
                case 2:
                case 6:
                case 10:
                case 16:
                    // Inventory
                    return !providedData || !providedData.inventoryJsonLD || providedData.inventoryJsonLD.length == 0;
                case 7:
                    // Bio
                    return !block.display || block.display.length == 0;
                case 17:
                    // Sign Up (always non-empty)
                    return false;
                case 15:
                case 19:
                case 20:
                case 21:
                    // Blog
                    return !providedData || !providedData.blogsJsonLD || providedData.blogsJsonLD.length == 0;
                case 22:
                case 23:
                case 24:
                case 27:
                    // Media
                    return false;
                case 3:
                case 26:
                case 30:
                    // Exhibitions
                    return !providedData || !providedData.showsJsonLD || providedData.showsJsonLD.length == 0;
                case Types.Block.Name.Artist.Bio.Text: {
                    // Artist Bio
                    const artist = providedData && providedData.artist || config && config.artist;
                    componentState.visible = artist && !Utilities.isHTMLContentEmpty(artist.bio);
                    break;
                }
                case Types.Block.Name.Artist.CV: {
                    // Artist CV
                    const artist = providedData && providedData.artist || config && config.artist;
                    componentState.visible = artist && !Utilities.isHTMLContentEmpty(artist.curriculumVitae);
                    break;
                }
                case Types.Block.Name.Artist.ImageV1:
                case Types.Block.Name.Artist.ImageV2:
                    // Artist Image
                    const artist = providedData && providedData.artist || config && config.artist;
                    componentState.visible = artist && artist.profile;
                    break;
                case Types.Block.Name.Artist.List:
                case Types.Block.Name.Artist.ListV2:
                case Types.Block.Name.Show.Artist.List:
                case Types.Block.Name.Show.Artist.ListV2:
                    // Artists
                    componentState.pending = true;
                    componentState.visible = Types.Block._checkTagsInJsonLD(providedData && providedData.artistJsonLD, block.config && block.config.block && block.config.block.tags);
                    break;
                case Types.Block.Name.Artist.Blog.List:
                case Types.Block.Name.Blog.List:
                case Types.Block.Name.Inventory.Blog.List:
                case Types.Block.Name.Show.Blog.List:
                    // Blog
                    componentState.pending = true;
                    componentState.visible = Types.Block._checkTagsInJsonLD(providedData && providedData.blogsJsonLD, block.config && block.config.block && block.config.block.tags);
                    break;
                case Types.Block.Name.InstallationPhotos:
                    // Installation Photos
                    componentState.visible = providedData && providedData.show && providedData.show.photos && providedData.show.photos.length > 0;
                    break;
                case Types.Block.Name.Inventory.Text: {
                    // Inventory Meta (tokenized text, e.g. Provenance) => Visible only if the token resolves to content
                    const design = block.config && block.config.block && block.config.block.design;
                    const inventory = providedData && providedData.inventory || {};
                    const edition = InventoryHelper.edition(inventory) || {};
                    const isArtist = config && config.userType == 1;
                    const parsed = design && Token.parseTokenizedString(design, (keyword, options) => Token.parsing.inventory({ edition, inventory, isArtist }, keyword, options));
                    componentState.visible = !Utilities.isHTMLContentEmpty(parsed);
                    break;
                }
                case Types.Block.Name.Artist.Inventory.ListV1:
                case Types.Block.Name.Artist.Inventory.ListV2:
                case Types.Block.Name.Artist.Inventory.ListV3:
                case Types.Block.Name.Artist.Inventory.ListV4:
                case Types.Block.Name.Inventory.ListV1:
                case Types.Block.Name.Inventory.ListV2:
                case Types.Block.Name.Inventory.ListV3:
                case Types.Block.Name.Inventory.ListV4:
                case Types.Block.Name.Inventory.Presentation.List:
                case Types.Block.Name.Inventory.RelatedV1:
                case Types.Block.Name.Inventory.RelatedV2:
                case Types.Block.Name.Inventory.RelatedV3:
                case Types.Block.Name.Inventory.RelatedV4:
                case Types.Block.Name.Show.Inventory.ListV1:
                case Types.Block.Name.Show.Inventory.ListV2:
                case Types.Block.Name.Show.Inventory.ListV3:
                case Types.Block.Name.Show.Inventory.ListV4:
                    // Inventory
                    componentState.pending = true;
                    componentState.visible = Types.Block._checkTagsInJsonLD(providedData && providedData.inventoryJsonLD, block.config && block.config.block && block.config.block.tags);
                    break;
                case Types.Block.Name.Artist.Media.List:
                case Types.Block.Name.Inventory.Media.List:
                case Types.Block.Name.Media.List:
                case Types.Block.Name.Show.Media.List:
                    componentState.pending = true;
                    componentState.visible = Types.Block._checkTagsInJsonLD(providedData && providedData.mediaJsonLD, block.config && block.config.block && block.config.block.tags);
                    break;
                case Types.Block.Name.Representative.List:
                    // Representative
                    componentState.pending = true;
                    componentState.visible = Types.Block._checkTagsInJsonLD(providedData && providedData.representativeJsonLD);
                    break;
                case Types.Block.Name.Artist.Show.List.Grid:
                case Types.Block.Name.Artist.Show.List.Parallax:
                case Types.Block.Name.Artist.Show.List.Slideshow:
                case Types.Block.Name.Artist.Show.List.SlideshowFullBackground:
                case Types.Block.Name.Show.List.Grid:
                case Types.Block.Name.Show.List.Parallax:
                case Types.Block.Name.Show.List.Slideshow:
                case Types.Block.Name.Show.List.SlideshowFullBackground:
                    // Exhibitions
                    componentState.pending = true;
                    componentState.visible = Types.Block._checkTagsInJsonLD(providedData && providedData.showsJsonLD, block.config && block.config.block && block.config.block.tags);
                    break;
                case Types.Block.Name.Show.Description:
                    // Exhibition Meta (Description)
                    componentState.visible = providedData && providedData.show && !Utilities.isHTMLContentEmpty(providedData.show.about);
                    break;
                case Types.Block.Name.Show.ImageV1:
                case Types.Block.Name.Show.ImageV2:
                    // Exhibition Image
                    componentState.visible = providedData && providedData.show && providedData.show.image;
                    break;
                case Types.Block.Name.Show.TitleV1:
                case Types.Block.Name.Show.TitleV2:
                    // Exhibition Meta (Title)
                    componentState.visible = providedData && providedData.show && providedData.show.title && providedData.show.title.length > 0;
                    break;
                case Types.Block.Name.Columns:
                    const values = [componentState];
                    if (block.blocks) {
                        for (let i = 0; i < block.blocks.length; i++) {
                            const columnBlocks = block.blocks[i];
                            for (let j = 0; j < columnBlocks.length; j++) {
                                const temp = Types.Block.isComponentEmpty(columnBlocks[j], providedData);
                                if (temp) {
                                    values.push(temp);
                                }
                            }
                        }
                    }
                    return values;
            }
            return [componentState];
        },
        isCustomGroupBlock: (type) => Types.Block.Name.Group[type] != undefined,
        isCustomTemplateBlock: (type) => {
            let isCustomTemplateBlock = false;
            for (let key in Name.Template) {
                let names = Name.Template[key];
                switch (key) {
                    case PageType.Footer:
                    case PageType.Header:
                        names = names.desktop;
                        break;
                }
                if (!names) {
                    continue;
                }
                isCustomTemplateBlock = names[type] != undefined;
                if (isCustomTemplateBlock) {
                    break;
                }
            }
            return isCustomTemplateBlock;
        }
    },
    FormField,
    InventoryCTAButtonType,
    Kit,
    PageType,
    ScreenSize,
    SocialPlatform: Name.SocialPlatform,
    Template: {
        Name: Name.Template
    },
    Themes: Layout.Type.Theme,
    Token
};

export default Types;